/* eslint-disable no-console */
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import { FallbackComponent } from './src/components/FallbackModal/FallbackComponent';
import { AuthContextProvider } from './src/contexts/AuthContext';
import { theme } from './src/theme';
import { navigate } from 'gatsby';

export const onRouteUpdate = ({ location }) => {
  if (
    process.env.GATSBY_MAINTENANCE_MODE === 'true' &&
    location.pathname !== '/maintenance'
  ) {
    navigate('/maintenance');
  }
};

export const wrapRootElement = ({ element }) => {
  const handleError = async (error, { componentStack }) => {
    if (process.env.NODE_ENV === 'production') {
      try {
        await fetch(`${process.env.GATSBY_API_URL}/gitlab-issues`, {
          method: 'POST',
          body: JSON.stringify({
            error: { title: error?.message, description: error.toString() },
            path: window.location.href,
            stack: componentStack
          }),
          headers: new Headers({ 'Content-type': 'application/json' })
        });
      } catch (e) {
        console.error("Impossible de signaler l'erreur");
      }
    }
  };

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <ErrorBoundary
          FallbackComponent={FallbackComponent}
          onError={handleError}
        >
          <AuthContextProvider>{element}</AuthContextProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </HelmetProvider>
  );
};
